import { action, makeObservable, observable } from "mobx";
import {
  getVaultByUuid,
  listVaults,
  updateVault,
  createVault,
} from "../../services";

class VaultStore {
  vault = {
    id: '',
    tenant_id: '',
    name: '',
    status: '',
    insert_date: '',
    last_modified: '',
    active: false
  };
  vaultList = {
    data: []
  };
  vaultUpdated = {
    uuid: '',
    name: '',
    description: '',
    category: '',
    imageUrl: '',
    updatedAt: '',
    msgCode: ''
  };
  vaultCreated = {
    uuid: '',
    name: '',
    status: '',
    msgCode: '',
    updatedAt: ''
  };
  agentAssigned = {
    data: {
      vaultUuid: '',
      agentUuid: '',
      grantedAt: '',
      status: '',
      privilege: '',
      description: ''
    },
    msgCode: '',
    requestId: ''
  };
  currentVaultId = '';
  isLoadingVaults = false;
  isErrorLoadingVaults = false;
  isErrorMessage = '';

  constructor() {
    makeObservable(this, {
      vault: observable,
      vaultList: observable,
      vaultUpdated: observable,
      vaultCreated: observable,
      agentAssigned: observable,
      currentVaultId: observable,
      isLoadingVaults: observable,
      isErrorLoadingVaults: observable,
      isErrorMessage: observable,
      setVault: action,
      setVaultList: action,
      setVaultUpdated: action,
      setVaultCreated: action,
      setAgentAssigned: action,
      fetchVault: action,
      fetchVaultList: action,
      createVault: action,
      updateVault: action,
      setCurrentVaultId: action,
      setIsErrorMessage: action
    });
  }

  setVault = (data) => { this.vault = data; };
  setVaultList = (data) => { this.vaultList = data; };
  setVaultUpdated = (data) => { this.vaultUpdated = data; };
  setVaultCreated = (data) => { this.vaultCreated = data; };
  setAgentAssigned = (data) => { this.agentAssigned = data; };
  setCurrentVaultId = (vaultId) => { this.currentVaultId = vaultId; };
  setIsErrorMessage = (error) => { this.isErrorMessage = error; };

  fetchVault = async (uuid) => {
    const { data } = await getVaultByUuid(uuid);
    this.setVault(data);
  };

  fetchVaultList = async (body) => {
    try {
      this.isLoadingVaults = true;
      this.isErrorLoadingVaults = false;
      
      const { data } = await listVaults(body);
      this.setVaultList(data);

    } catch (error) {
      this.isErrorLoadingVaults = true;
      this.setIsErrorMessage("Error fetching drives list, try again later");
    } finally {
      this.isLoadingVaults = false;
    }
  };

  createVault = async (body) => {
    const { data } = await createVault(body);
    this.setVaultCreated(data);
  };

  updateVault = async (uuid, tenantId, body) => {
    const { data } = await updateVault(uuid, tenantId, body);
    this.setVaultUpdated(data);
  };
}

export default VaultStore;
